import { useTranslation } from 'react-i18next';
import { FormTemplateQuestionFieldOptionsValidityHintEnum } from 'graphql-common';
import { FieldItem } from '@lib/interfaces/form';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';
import SelectPanel from '@lib/components/SelectPanel/SelectPanel';
import { ValidityHintOption } from '@lib/components/SelectPanel/options';
import DateRangePicker from '@lib/components/DateTimePicker/DateRangePicker';
import formStyles from '@lib/assets/styles/Form.module.scss';
import { InputSizes } from '@lib/components/Input/enums';
import FieldNames from '@lib/enums/fieldNames/taskCompletionsFilterFieldNames';
import getValidityHintOptions from '../../utils/getValidityHintOptions';
import styles from './getFilterFields.module.scss';

export default function useFilterFields({
  excludedValidityHints,
}: {
  // Status options that would never match anything given the picker's own
  // `baseFilters` — e.g. the Intervention form excludes "Success" since it
  // never offers non-conform-only completions. Purely cosmetic (hides a
  // dead-end option); the actual restriction lives in `baseFilters`.
  excludedValidityHints?: FormTemplateQuestionFieldOptionsValidityHintEnum[];
} = {}): FieldItem[] {
  const { t } = useTranslation();

  return [
    {
      name: FieldNames.ValidityHints,
      label: t('status'),
      element: SelectPanel,
      validation: getOptionsArrayValidation({ t }),
      formItemClassName: formStyles.formColumnAuto,
      hideErrorsSpace: true,
      componentProps: {
        searchable: false,
        isMulti: true,
        options: getValidityHintOptions(excludedValidityHints),
        renderOption: ValidityHintOption,
        buttonProps: {
          buttonText: t('status'),
        },
      },
      isOptionalFn: () => false,
    },
    {
      name: FieldNames.Period,
      label: t('period'),
      element: DateRangePicker,
      formItemClassName: styles.periodField,
      hideErrorsSpace: true,
      componentProps: {
        size: InputSizes.medium,
      },
      isOptionalFn: () => false,
    },
  ];
}
